import DynamicFormFieldInputTypeResourceModel from '../../generated/types/model/resource/DynamicFormFieldInputTypeResourceModel';

// type DynamicFormFieldInputTypeResourceViewModel = DynamicFormFieldInputTypeResourceModel;
// export default DynamicFormFieldInputTypeResourceViewModel;

// TODO: Use generated enums once available

// eslint-disable-next-line no-shadow
enum DynamicFormFieldInputTypeResourceViewModel {
  Unknown = 0,
  /** A title or heading */
  Heading = 1,
  /** A paragraph of text */
  Paragraph = 2,
  /** A single line of text */
  TextInputSingleLine = 3,
  /** A multiline text */
  TextInputMultiLine = 4,
  /** A text containing an email-address */
  TextInputEmail = 5,
  /** A text containing a phone number */
  TextInputPhone = 6,
  /** A number value */
  NumberInput = 7,
  /** A date value */
  DateInput = 8,
  /** A datetime value */
  DateTimeInput = 9,
  /** A time value */
  TimeInput = 10,
  /** Boolean decision, usually a checkbox */
  DecisionInput = 11,
  /** RadioButtons/Dropdown accepting only one answer */
  SelectSingleInput = 12,
  /** Checkbox/Listbox accepting multiple answers */
  SelectMultipleInput = 13,
  /** File upload */
  FileSingleInput = 14,
  /** File upload */
  FileMultipleInput = 15,
  /** A group/section of field items */
  Group = 16
}

export default DynamicFormFieldInputTypeResourceViewModel;
